module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addCategoryButton":"Kategorie hinzufügen","nameTitle":"Name","editButton":"Bearbeiten","cancelButton":"Abbrechen","alreadyExistsError":"Name bereits vorhanden","pendingLabel":"Wird gespeichert...","deleteConfirmation":"Wollen Sie diese Kategorie wirklich löschen? Dabei gehen alle Zuordnungen zu Gebäuden verloren.","noTags":"Es sind noch keine Kategorien vorhanden"}}')
  delete Component.options._Ctor
}
